import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';
import FormStyles from 'styles/mixins/Form.styles';

const StyledFieldAddDialog = styled(Dialog)`
  .MuiDialog-paper {
    min-width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
    max-width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
  }

  .InlineForm {
    .FormControl {
      &.FormField-name-autoLookup {
        row-gap: ${props => props.theme.layout(0)};
        .List {
          width: fit-content;
        }
      }
    }
  }
  
  ${FormStyles}
  ${ComponentStyles}
`;

StyledFieldAddDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledFieldAddDialog;
